// The "Added to Friday gig" notice (components/playlistAdded.ts) as a toast
// with Open, which goes to that playlist, and Undo, which takes the row back
// out. Mounted once in the app shell, so it shows wherever the add was made
// and whichever way it was made.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '@/navigation';
import { useStore } from '@/state/store';
import { Toast } from './Toast';
import { dismissPlaylistAdded, usePlaylistAdded } from './playlistAdded';

/** How long the notice stays: long enough to reach for Open or Undo. */
const NOTICE_MS = 6000;

export function PlaylistAddedToast() {
  const notice = usePlaylistAdded();
  const navigate = useNavigate();
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => dismissPlaylistAdded(notice.id), NOTICE_MS);
    return () => window.clearTimeout(timer);
  }, [notice]);
  if (!notice) return null;
  const { id, playlistId, playlistName, entryId } = notice;
  return (
    <Toast
      testId="tune-added"
      actions={[
        {
          label: 'Open',
          testId: 'tune-added-open',
          onClick: () => {
            dismissPlaylistAdded(id);
            navigate(`${APP_ROUTES.playlists}/${playlistId}`);
          },
        },
        {
          label: 'Undo',
          testId: 'tune-added-undo',
          onClick: () => {
            // The row this add made, if it is still there: never another copy.
            const list = useStore.getState().userPlaylists.find((p) => p.id === playlistId);
            if (entryId && list?.entries.some((e) => e.entryId === entryId))
              useStore.getState().removeFromPlaylist(playlistId, entryId);
            dismissPlaylistAdded(id);
          },
        },
      ]}
    >
      Added to {playlistName}
    </Toast>
  );
}
